import React from 'react'
import styled from 'styled-components'
import AIcon from '../../../../assets/codicons/a.svg'
import CommonLink from 'components_v2/CommonLink'

const Main = styled.div`
  display: flex;
  align-items: flex-start;
  margin-top: 10%;

  .empty-header {
    max-width: 800px;
    margin: 0 15px;
  }

  p {
    color: #000000;
    font-size: 13px;
    line-height: 20px;
  }

  @media (min-width: 768px) {
    .empty-header {
      width: 80%;
      margin: 0 auto;
    }

    p {
      font-size: 16px;
    }
  }
`

const NotAvailable = () => {
  return (
    <Main className='row empty-state'>
      <AIcon className='codicon codicon-a' />
      <div>
        <h3 className='empty-header'>
          This Program is no longer available
          <p>
            We're sorry but this Program has been removed from our site. Please{' '}
            <CommonLink className='see-more' to='/explore'>
              explore our library
            </CommonLink>{' '}
            to find something else.
          </p>
        </h3>
      </div>
    </Main>
  )
}

export default NotAvailable
